const DEFAULT_FORUM_URL = 'https://pokemonrevolution.net/forum/'

function configuredForumBase () {
  return (process.env.VUE_APP_FORUM_URL || DEFAULT_FORUM_URL).trim() || DEFAULT_FORUM_URL
}

export function forumUrl (path = '/') {
  try {
    return new URL(path, configuredForumBase()).toString()
  } catch (e) {
    return new URL(path, DEFAULT_FORUM_URL).toString()
  }
}
